<template>
    <div class="servico">
        <!-- Página: Esteiras Elétricas -->
        <section id="esteiras" class="servico-section">
            <h2>Montagem e Manutenção de Esteiras Elétricas</h2>
            <img src="@/assets/images/esteira.jpg" alt="Esteira Industrial" class="servico-img" />
      <h2>Serviços para esteiras industriais e de fitness</h2>
      <ul class="servico-lista">
        <li><button @click="abrirModal('modal1')">Reparação de esteiras industriais e de fitness</button></li>
        <li><button @click="abrirModal('modal2')">Substituição de motores, correias e placas de controle</button></li>
      </ul>
    </section>

    <!-- Modal 1 -->
    <div v-if="modalAberto === 'modal1'" class="modal-overlay">
      <div class="modal-content">
        <h3>Reparação de esteiras industriais e de fitness</h3>
        <p><strong>Descrição:</strong>:  Diagnóstico e conserto de motores, correias e controles</p>
        <p><strong>Benefício:</strong> Garante continuidade em indústrias e academias</p>
        <p><strong>Exemplo:</strong> Reparo de esteira de academia no Bairro da Luz</p>
        <p><strong>Prazo:</strong> Simples (2-4 horas); Complexo (1-2 dias)</p>
        <p><strong>Pagamento:</strong> Simples (completo); Complexo (diagnóstico + parcelado)</p>
        <p><strong>Normas:</strong>  ISO 9001, CE</p>
        <button class="fechar-btn" @click="fecharModal">Fechar</button>
      </div>
    </div>

    <!-- Modal 2 -->
    <div v-if="modalAberto === 'modal2'" class="modal-overlay">
      <div class="modal-content">
        <h3>Substituição de motores, correias e placas de controle</h3>
        <p><strong>Descrição:</strong> Troca de peças danificadas</p>
        <p><strong>Benefício:</strong>  Restaura funcionalidade e segurança</p>
        <p><strong>Exemplo:</strong>  Substituição de correia em esteira industrial</p>
        <p><strong>Prazo:</strong> Complexo (1-2 dias)</p>
        <p><strong>Pagamento:</strong> Diagnóstico + parcelado</p>
        <p><strong>Normas:</strong> CE, ISO 9001</p>
        <button class="fechar-btn" @click="fecharModal">Fechar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalAberto: null,
    };
  },
  methods: {
    abrirModal(modalId) {
      this.modalAberto = modalId;
    },
    fecharModal() {
      this.modalAberto = null;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.servico {
  padding: 40px;
  font-family: Arial, sans-serif;
  background-color: #f9f9f9;
}

.servico-section {
  margin-bottom: 60px;
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.servico-section h1,
h2 {
  text-align: center;
  color: #005580;
  margin-bottom: 20px;
}

.servico-section h1 {
  font-size: 28px;
  border-bottom: 2px solid #005580;
  padding-bottom: 10px;
}

.servico-section h2 {
  font-size: 20px;
  font-weight: normal;
}

.servico-img {
  display: block;
  margin: 0 auto 20px auto;
  width: 50%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
}

.servico-lista {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.servico-lista li button {
  background-color: #005580;
  color: white;
  border: none;
  padding: 12px 18px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;
  text-align: center;
}

.servico-lista li button:hover {
  background-color: #0077a6;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease-in-out;
}

.modal-content h3 {
  margin-top: 0;
  color: #005580;
  margin-bottom: 20px;
  text-align: center;
}

.modal-content p {
  margin: 10px 0;
  line-height: 1.5;
  color: #333;
}

.fechar-btn {
  display: block;
  margin: 20px auto 0 auto;
  background-color: #cc0000;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.fechar-btn:hover {
  background-color: #e60000;
}

@keyframes fadeIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>